/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../types/schema.generated';

import gql from 'graphql-tag';
import { SettingsPagePlannerFragmentDoc } from '../SettingsPage/SettingsPage.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type FetchViewerOnChatPageQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchViewerOnChatPageQuery = { viewer: { id: string, hasLineActivationProvider: boolean }, uiControl: { viewMatchedRooms: boolean, viewBranchMemberRooms: boolean, viewCorporationMemberRooms: boolean } };

export type ChatPageUiControlFragment = { viewMatchedRooms: boolean, viewBranchMemberRooms: boolean, viewCorporationMemberRooms: boolean };

export type FetchPlannerOnChatPageQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchPlannerOnChatPageQuery = { planner: { id: string, name: string, slug: string, avatar: any, avatarUrl: string, cover: any, coverUrl: string | null, corporationId: string, branchIds: Array<string>, email: string, gender: string, birthday: DateString | null, availableTime: string, availableAreaCodes: Array<string>, role: string, comment: string, authorities: Array<string>, specialties: Array<{ id: string, name: string }> } | null };

export const ChatPageUiControlFragmentDoc = gql`
    fragment ChatPageUIControl on UIControl {
  viewMatchedRooms
  viewBranchMemberRooms
  viewCorporationMemberRooms
}
    `;
export const FetchViewerOnChatPageDocument = gql`
    query fetchViewerOnChatPage {
  viewer {
    id
    hasLineActivationProvider
  }
  uiControl {
    ...ChatPageUIControl
  }
}
    ${ChatPageUiControlFragmentDoc}`;

/**
 * __useFetchViewerOnChatPageQuery__
 *
 * To run a query within a Vue component, call `useFetchViewerOnChatPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchViewerOnChatPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchViewerOnChatPageQuery();
 */
export function useFetchViewerOnChatPageQuery(options: VueApolloComposable.UseQueryOptions<FetchViewerOnChatPageQuery, FetchViewerOnChatPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchViewerOnChatPageQuery, FetchViewerOnChatPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchViewerOnChatPageQuery, FetchViewerOnChatPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchViewerOnChatPageQuery, FetchViewerOnChatPageQueryVariables>(FetchViewerOnChatPageDocument, {}, options);
}
export function useFetchViewerOnChatPageLazyQuery(options: VueApolloComposable.UseQueryOptions<FetchViewerOnChatPageQuery, FetchViewerOnChatPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchViewerOnChatPageQuery, FetchViewerOnChatPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchViewerOnChatPageQuery, FetchViewerOnChatPageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchViewerOnChatPageQuery, FetchViewerOnChatPageQueryVariables>(FetchViewerOnChatPageDocument, {}, options);
}
export type FetchViewerOnChatPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchViewerOnChatPageQuery, FetchViewerOnChatPageQueryVariables>;
export const FetchPlannerOnChatPageDocument = gql`
    query fetchPlannerOnChatPage {
  planner {
    ...SettingsPagePlanner
  }
}
    ${SettingsPagePlannerFragmentDoc}`;

/**
 * __useFetchPlannerOnChatPageQuery__
 *
 * To run a query within a Vue component, call `useFetchPlannerOnChatPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchPlannerOnChatPageQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useFetchPlannerOnChatPageQuery();
 */
export function useFetchPlannerOnChatPageQuery(options: VueApolloComposable.UseQueryOptions<FetchPlannerOnChatPageQuery, FetchPlannerOnChatPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchPlannerOnChatPageQuery, FetchPlannerOnChatPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchPlannerOnChatPageQuery, FetchPlannerOnChatPageQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<FetchPlannerOnChatPageQuery, FetchPlannerOnChatPageQueryVariables>(FetchPlannerOnChatPageDocument, {}, options);
}
export function useFetchPlannerOnChatPageLazyQuery(options: VueApolloComposable.UseQueryOptions<FetchPlannerOnChatPageQuery, FetchPlannerOnChatPageQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<FetchPlannerOnChatPageQuery, FetchPlannerOnChatPageQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<FetchPlannerOnChatPageQuery, FetchPlannerOnChatPageQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<FetchPlannerOnChatPageQuery, FetchPlannerOnChatPageQueryVariables>(FetchPlannerOnChatPageDocument, {}, options);
}
export type FetchPlannerOnChatPageQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<FetchPlannerOnChatPageQuery, FetchPlannerOnChatPageQueryVariables>;